// extracted by mini-css-extract-plugin
module.exports = {"actionBox":"KModal_actionBox__2FubC","bodyText":"KModal_bodyText__3K_UK","rootBox":"KModal_rootBox__U6xeG","rootModal":"KModal_rootModal__3K-cD"};